<script context='module'>
  import { getContext, onMount } from 'svelte';

  export const CONTEXT_KEY = Symbol('AllOrganizationsProvider.CONTEXT_KEY');
  export const useAllOrganizations = () => getContext(CONTEXT_KEY);
</script>

<script>
  import { writable } from 'svelte/store';
  import Provider from '@commercebear/components/Provider';
  import { useApi } from '../ApiProvider';

  const api = useApi();

  const value = writable([]);

  onMount(async () => {
    const { body: { items: allOrganizations } } = await $api.organizations.getOrganizations();
    $value = allOrganizations;
  });
</script>

<Provider key={CONTEXT_KEY} {value}>
  <slot />
</Provider>
